module.exports = __webpack_public_path__ + "img/6_27.63ea1371.png";